import { createRoute, redirect } from "@tanstack/react-router";

import { rootRoute } from "@platform/root";
import { sessionQueryOptions } from "@platform/auth/guards";
import { AcceptInvitationPage } from "./accept-invitation.page";

// Public landing for invitation links. Acceptance needs a session. Without one
// the route bounces through /login, which auto-registers the invitee, and comes
// back here through the redirect param.
export const acceptInvitationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/accept-invitation",
	validateSearch: (search: Record<string, unknown>): { id: string } => ({
		id: typeof search.id === "string" ? search.id : "",
	}),
	beforeLoad: async ({ context, search }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueryOptions);
		if (!session?.user) {
			throw redirect({
				to: "/login",
				search: { redirect: `/accept-invitation?id=${encodeURIComponent(search.id)}` },
			});
		}
	},
	component: AcceptInvitationPage,
});
